export default __webpack_public_path__ + "static/media/SunFilm.6038dd3d.jpg";